import { render, staticRenderFns } from "./damagesDetails.pug?vue&type=template&id=4481c69e&lang=pug&external"
import script from "./damagesDetails.js?vue&type=script&lang=js&external"
export * from "./damagesDetails.js?vue&type=script&lang=js&external"
import style0 from "./damagesDetails.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4481c69e')) {
      api.createRecord('4481c69e', component.options)
    } else {
      api.reload('4481c69e', component.options)
    }
    module.hot.accept("./damagesDetails.pug?vue&type=template&id=4481c69e&lang=pug&external", function () {
      api.rerender('4481c69e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/damagesDetails/index.vue"
export default component.exports